import { Injectable } from '@angular/core';

import { Selector, StateContext, Action, State } from '@ngxs/store';

import {
  SetOfferAction,
  RemoveOfferAction,
  SetServiceRequestAction,
  RemoveServiceRequestAction,
  SetTiresServiceRequestAction,
  RemoveTiresServiceRequestAction,
} from './offer.actions';
import { OfferServices, OfferStateModel } from './offer.model';

const INITIAL_STATE: OfferStateModel = {
  offer: null,
  service_request: null,
  customized_tires_request: null,
};

@State<OfferStateModel>({
  name: 'offer',
  defaults: INITIAL_STATE,
})
@Injectable()
export class OfferState {
  @Selector()
  static offerData(state: OfferStateModel): OfferStateModel {
    return state;
  }

  @Selector()
  static servicesData(state: OfferStateModel): OfferServices {
    const { offer } = state;

    return {
      extras: offer?.extras,
      mechanical_orders: offer.mechanical_orders,
    };
  }

  @Action(SetOfferAction)
  setOfferAction(
    ctx: StateContext<OfferStateModel>,
    action: SetOfferAction
  ): void {
    ctx.patchState({
      offer: action.offer,
    });
  }

  @Action(SetServiceRequestAction)
  setServiceRequestAction(
    ctx: StateContext<SetServiceRequestAction>,
    action: SetServiceRequestAction
  ): void {
    ctx.patchState({
      service_request: action.service_request,
    });
  }

  @Action(SetTiresServiceRequestAction)
  setTiresServiceRequestAction(
    ctx: StateContext<SetTiresServiceRequestAction>,
    action: SetTiresServiceRequestAction
  ): void {
    ctx.patchState({
      customized_tires_request: action.customized_tires_request,
    });
  }

  @Action(RemoveOfferAction)
  removeOfferAction(ctx: StateContext<OfferStateModel>): void {
    ctx.patchState({
      offer: INITIAL_STATE.offer,
    });
  }

  @Action(RemoveServiceRequestAction)
  removeServiceRequestAction(
    ctx: StateContext<RemoveServiceRequestAction>
  ): void {
    ctx.patchState({
      service_request: INITIAL_STATE.service_request,
    });
  }

  @Action(RemoveTiresServiceRequestAction)
  removeTiresServiceRequestAction(
    ctx: StateContext<RemoveTiresServiceRequestAction>
  ): void {
    ctx.patchState({
      customized_tires_request: INITIAL_STATE.customized_tires_request,
    });
  }
}
